import React from 'react';
import CarCard from './CarCard';
import pc1 from './Images/pc1.png';
import pc2 from './Images/pc2.png';
import pc3 from './Images/pc3.png';
import pc4 from './Images/pc4.png';
import pc5 from './Images/pc5.png';
import pc6 from './Images/pc6.png';
import { FaArrowRight } from 'react-icons/fa';

const carList=[
  {
    brand: "Toyota",
    name: "Toyota Camry SE 350",
    image: pc1,
    reviews: 138,
    price: 160,
    distance: 10,
    fuel: "Diesel",
    year: 2018
  },
   {
    brand: "Toyota",
    name: "Audi A3 2019 new",
    image: pc2,
    reviews: 150,
    price: 45,
    distance: 10,
    fuel: "Diesel",
    year: 2019
  },
  {
    brand: "Toyota",
    name: "Ford Mustang 4.0 AT",
    image: pc3,
    reviews: 170,
    price: 90,
    distance: 10,
    fuel: "Petrol",
    year: 2021
  },
  {
    brand: "Hyundai",
    name: "Hyundai i20 Sportz",
    image:pc4,
    reviews: 112,
    price: 35,
    distance: 12,
    fuel: "Petrol",
    year: 2020
  },
  {
    brand: "Kia",
    name: "Kia Seltos HTX",
    image:pc5,
    reviews: 97,
    price: 60,
    distance: 11,
    fuel: "Diesel",
    year: 2023
  },
  {
    brand: "Honda",
    name: "Honda Civic",
    image:pc6,
    reviews: 144,
    price: 75,
    distance: 10,
    fuel: "Petrol",
    year: 2022
  }
];
function Cars() {
  return (
    <>
     <h2 className="mb-3  fw-bold text-center">
          <span role="img" aria-label="spark">
            ✨
          </span>{" "}
          Explore Most Popular Cars{" "}
          <span role="img" aria-label="spark">
            ✨
          </span>
        </h2>
        <p className='text-center'>
          Here's a list of some of the most popular cars globally
        </p>
    <div className='container py-4'>
      <div className='row g-4'>
    {carList.map((car,index)=>(
        <div className='col-md-4' key={index} >
            <CarCard car={car}/>
        </div>
    ))}
      </div>
    </div>
    <div className='text-center'>
        <button type='submit' className='btn btn-dark custom-hover'>View More Cars <FaArrowRight /></button>
    </div>
    </>
  )
}

export default Cars
